import { Injectable } from '@angular/core';
import { IAction } from '@shared/interfaces/action.interface';
import { IFilter } from '@shared/interfaces/filter.interface';
import { Filter } from '@shared/models/filter.model';
import { ActionsService } from '@shared/services/actions.service';
import { LoggerService } from '@shared/services/logger.service';
import { PaginationService } from '@shared/services/pagination/pagination.service';

@Injectable({
  providedIn: 'root'
})
export class PaginationActionsService extends PaginationService<IAction> {
  private static readonly DEFAULT_IS_DELETED_FILTER: IFilter = {
    label: 'COMMON.ACTIVE',
    key: 'isDeleted',
    value: 'false'
  };

  private static readonly DEFAULT_OWNERSHIP_FILTER: IFilter = {
    label: 'FILTERS.MYSELF',
    key: 'owner',
    value: 'my'
  };

  private static readonly DEFAULT_STATUS_FILTER: IFilter = {
    label: 'FILTERS.NOT_COMPLETED',
    key: 'completedAt',
    value: 'false'
  };

  private static readonly DEFAULT_SEARCH_FILTER: IFilter = {
    key: 'search',
    value: null
  };

  private _filtersScope: any;

  constructor(_paginable: ActionsService, _logger: LoggerService) {
    super(_paginable, _logger);

    this.setFilters([
      PaginationActionsService.DEFAULT_IS_DELETED_FILTER,
      PaginationActionsService.DEFAULT_OWNERSHIP_FILTER,
      PaginationActionsService.DEFAULT_STATUS_FILTER,
      PaginationActionsService.DEFAULT_SEARCH_FILTER
    ]);
  }

  public getFilters(): IFilter[] {
    return this._filtersScope;
  }

  public reset() {
    super.reset();

    this.setFilters([
      PaginationActionsService.DEFAULT_IS_DELETED_FILTER,
      PaginationActionsService.DEFAULT_OWNERSHIP_FILTER,
      PaginationActionsService.DEFAULT_STATUS_FILTER,
      PaginationActionsService.DEFAULT_SEARCH_FILTER
    ]);
  }

  public setFilters(filters: Partial<IFilter>[]): void {
    this._filtersScope = filters.map((f) => new Filter(f));
    super.setFilters(this._filtersScope);
  }
}
